import { onReady } from './utils/on-ready';
import { MDCDialog } from '@material/dialog';

export class ApProfileCard {
    constructor() {
        onReady(this.initialize);
    }

    initialize = () => {
        //This will be revisited at a later date for the horizontal scroll.
        //const scrollContainer = document.querySelector(".ap-card-scroll__wrapper__scroll");

        //scrollContainer.addEventListener("wheel", function (e) {
        //    e.preventDefault();

        //    scrollContainer.scrollLeft += (e as MouseWheelEvent).deltaY;
        //});
    }

    showProfileDialog = (staffId: any): void => {
        const dialog = MDCDialog.attachTo(document.querySelector('.staff-dialog-' + staffId));

        dialog.open();
    };
}